/* eslint-disable global-require */
if (typeof window !== 'undefined') {
    require('codemirror/addon/lint/lint.css');
    require('codemirror/addon/lint/lint');
    require('codemirror/addon/lint/html-lint');
}
